export const locales = [
    {
        code: 'de',
        name: 'Deutsch',
    },
    {
        code: 'en',
        name: 'english',
    },
    {
        code: 'it',
        name: 'Italiano',
    },
    {
        code: 'fr',
        name: 'Français',
    },
];

export const localesCodes = locales.map(({ code }) => code);
export const localesDefault = 'de';

const getLocalesUserDefault = (): string => {
    try {
        const storedLocale = window.localStorage.getItem('locale');
        if (storedLocale !== null) {
            if (localesCodes.includes(storedLocale)) {
                return storedLocale;
            }
        }
    } catch {
        // local storage error
    }

    const userLanguage = window.navigator.language;
    let lang = userLanguage ? userLanguage.split('-')[0] : localesDefault;
    lang = localesCodes.includes(lang) ? lang : localesDefault;
    return lang;
};

export const localesUserDefault = getLocalesUserDefault();

export const localeNameByCode = (code: string): string | null => {
    const locale = locales.find((l) => l.code === code);
    if (typeof locale === 'undefined') {
        return null;
    }
    return locale.name;
};
